// Google Tags loader with cookie consent gate.
// Charge gtag.js + GA4 + Google Ads conversion tracking — uniquement après
// que l'utilisateur a cliqué "Tout accepter" dans le bandeau cookies (RGPD/LPD).
const GA_ID = process.env.REACT_APP_GA_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const CONSENT_KEY = "cookie-consent";

let loaded = false;

export function initGA() {
  if (typeof window === "undefined" || loaded) return;
  if (!GA_ID && !ADS_ID) return;
  const consent = localStorage.getItem(CONSENT_KEY);
  if (consent !== "accepted") return;

  // gtag.js est partagé par GA4 et Google Ads — on charge avec le premier ID disponible
  const primaryId = GA_ID || ADS_ID;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${primaryId}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  if (GA_ID) gtag("config", GA_ID, { anonymize_ip: true });
  if (ADS_ID) gtag("config", ADS_ID);
  loaded = true;
}

export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

// Helper pour le suivi des conversions Google Ads (à appeler depuis votre code)
// Usage: trackAdsConversion('XXXXXXXX', { value: 100, currency: 'CHF' })
export function trackAdsConversion(conversionLabel, params = {}) {
  if (!ADS_ID) return;
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: `${ADS_ID}/${conversionLabel}`,
      ...params,
    });
  }
}
